const Shimmer = () => {
  return (
    <div className="cardcontainer lg:px-24 lg:py-14 p-10 flex w-full flex-wrap">
      <div className="card">
        <div className="shadow-lg w-[200px] m-8 rounded-md ">
          <div className="w-[200px] h-[200px] bg-blue-200"></div>
          <div className="p-3">
            <h3 className="font-semibold">title</h3>
            <div className="text-[0.8rem] py-1">author</div>
            <div className="text-[0.8rem]">rating</div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="shadow-lg w-[200px] m-8 rounded-md ">
          <div className="w-[200px] h-[200px] bg-blue-200"></div>
          <div className="p-3">
            <h3 className="font-semibold">title</h3>
            <div className="text-[0.8rem] py-1">author</div>
            <div className="text-[0.8rem]">rating</div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="shadow-lg w-[200px] m-8 rounded-md ">
          <div className="w-[200px] h-[200px] bg-blue-200"></div>
          <div className="p-3">
            <h3 className="font-semibold">title</h3>
            <div className="text-[0.8rem] py-1">author</div>
            <div className="text-[0.8rem]">rating</div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="shadow-lg w-[200px] m-8 rounded-md ">
          <div className="w-[200px] h-[200px] bg-blue-200"></div>
          <div className="p-3">
            <h3 className="font-semibold">title</h3>
            <div className="text-[0.8rem] py-1">author</div>
            <div className="text-[0.8rem]">rating</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shimmer;
